import { EuroCircleOutlined } from "@ant-design/icons";
import { Divider, Typography } from "antd";

// import UnconfirmedPricesTable from "./UnconfirmedPricesTable";
import { useCollection } from "../../../hooks/useCollection";
import UnconfirmedPricesList from "./UnconfirmedPricesList";

const { Title } = Typography;

export default function UnconfirmedPrices() {
   //gets the data for calcuations
   //checks if its not approved or it has not been sent back
   const { loading, data } = useCollection("priceCalculation", ["aproved", "==", false], ["sentBack", "==", false]);

   return (
      <div>
         <Title level={3}>
            <EuroCircleOutlined />
            <Divider type="vertical" />
            Unconfirmed Prices
         </Title>
         <UnconfirmedPricesList data={data} loading={loading} />
      </div>
   );
}
